import React, { SetStateAction, useState } from 'react'
import styled from 'styled-components'
import { ActionButton, NextButton } from '../common/CommonStyled'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import DatePickerAdRecruit from './DatePickerAdRecruit'
import DateRangePickerAdRecruit from './DateRangePickerAdRecruit'
import { ModalAdSheduleAddStore } from 'src/stores/ModalStore'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    border-radius: 5px;
    border: 2px dashed #06799B;
    background: #EEF6F8;
    padding: 20px;
`

const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 600;

    margin-bottom: 8px;
`

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 30px;
    right: 0;
`
const LabelWarpper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 464px;
`

const LabelSpan = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 600;
`

const ElementWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

    width: 402px;
`
const RangeWrapper = styled.div<{ $isRange?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    background-color: white;
    height: 30px;
    min-width: 82px;
    box-sizing: border-box;
    border-radius: 2px;
    /* padding: 4px; */
    font-size: 12px;
    color: ${({ $isRange }) => ($isRange ? '#06799B' : '#545454')};
    border: 1px solid ${({ $isRange }) => ($isRange ? '#06799B' : '#D1D1D1')};
`

const RangeCheckBox = styled.input`
    width: 16px;
    height: 16px;
    margin: 0px;
`
interface Props{
    title : string
    set_isAdd? : React.Dispatch<SetStateAction<boolean>>
}

const AddEtc = ({title, set_isAdd}:Props) => {
    const [name,setName] = useState('')
    const [isRange, setIsRange] = useState(false)
    const addEtc = ModalAdSheduleAddStore((state)=>state.addEtc)
    const startdate = ModalAdSheduleAddStore((state)=>state.etcstartdate)
    const enddate = ModalAdSheduleAddStore((state)=>state.etcenddate)
    // const etc = ModalAdSheduleAddStore((state)=>state.etc)

    const handleCancle = ()=>{
        setName('')
        setIsRange(false)
        set_isAdd?.(false)
    }

    const handleAddEtc = (name:string,startdate:string|null,enddate:string|null)=>{
        const payload: (string | null)[] =
        enddate === null || enddate === '' ? [name, startdate] : [name, startdate, enddate];
        addEtc(payload)
        setName('')
    }
    return (
        <PageWrapper>
            <TitleWrapper>
                {title}
                <ButtonWrapper>
                    <ActionButton style={{width:'60px', fontSize: '12px'}} onClick={handleCancle}>취소</ActionButton>
                    <NextButton style={{width:'60px', fontSize: '12px', height:'100%'}} onClick={()=>handleAddEtc(name,startdate,enddate)}> 추가</NextButton>
                </ButtonWrapper>
            </TitleWrapper>
            <LabelWarpper>
                <LabelSpan>과정명</LabelSpan>
                <ElementWrapper><InputBoxOnChange value={name} onChange={(e)=>setName(e.target.value)} placeholder='과정명' height='30px' padding='6.5px 10px' fontSize='14px'/></ElementWrapper>
            </LabelWarpper>
            <LabelWarpper>
                <LabelSpan>일정</LabelSpan>
                <ElementWrapper>
                    {isRange ? 
                    <div style={{width: '100%', height:'30px'}}>
                    <DateRangePickerAdRecruit/>
                    </div>
                    :                    
                    <div style={{width:'144px', height:'30px'}}>
                    <DatePickerAdRecruit/>
                    </div>}
                    <RangeWrapper $isRange={isRange}>
                        <RangeCheckBox type="checkbox" checked={isRange} onChange={()=>setIsRange((state)=>!state)}/>
                        기간 입력
                    </RangeWrapper>
                </ElementWrapper>
            </LabelWarpper>
        </PageWrapper>
    )
}

export default AddEtc